import { render, staticRenderFns } from "./quemadura.vue?vue&type=template&id=0f157ac8&scoped=true&"
import script from "./quemadura.vue?vue&type=script&lang=js&"
export * from "./quemadura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f157ac8",
  null
  
)

export default component.exports